/** Bundled customer names for Add Project (from project board export, deduped). */
const CUSTOMERS = [
  "2PiFi, Inc",
  "2PiFi, Inc (Grand Coresite)",
  "6781 N Palm Data Center Build",
  "Activated Events-(Woodward Park, Fresno)",
  "Allensworth Elem. Sch Dist. (3200 Young Rd, Earlimart)",
  "Answer Mortgage Group (7473 N Ingram Ave STE 103)",
  "Aria Tulare Relocation",
  "Assemi Group- Palm",
  "ATT Wireline - Spreckles",
  "Ayera Technologies Inc",
  "Ballico-Cresset Elementary Sch Dist. (11818 Gregg St Ballico)",
  "Ballico-Cresset Elementary Sch Dist. (450 W. 18th St Merced)",
  "Caifornia Autism Center (971 E Broadway, Atwater)",
  "CalfTech (15003 Ave 136, Tipton)",
  "California Citrus Mutual",
  "Camarena Health",
  "Camerena Health (344 E. 6th St, Madera)",
  "CENIC - Akers Elementary (Lemoore NAS)",
  "CENIC - Alview Dairyland Union Elementary",
  "CENIC - AlView Elementary",
  "CENIC - Clovis Community College",
  "CENIC - El Dorado COE",
  "CENIC - Elk Hills Elementary",
  "CENIC - Fresno COE 2",
  "CENIC - Kings COE CommShelter",
  "CENIC - Madera Community College",
  "CENIC - Merced College - Business Resource Center",
  "CENIC - Merced College - Los Banos Center",
  "CENIC - Reedley College",
  "CENIC - SCCCD - Clovis Community College",
  "CENIC - SCCCD - Reedley College",
  "CENIC - Sutter Branch Library",
  "CENIC - Tulare COE",
  "CENIC - West Hills District Office - Lemoore College",
  "CENIC - Yuba COE",
  "Cenic- Cuyama Valley High (4500 Highway 166, New Cuyama)",
  "Cenic- Fresno Flats Comm. Day (43109 Highway 49, Ahwahnee)",
  "Cenic- Meadowbrook Comm. Day (45426 Road 415, Coarsegold)",
  "Cenic-Big Creek Elem. (1111 Van ness ave, Fresno)",
  "Cenic-Bitterwater-Tully Elem. (460 Fifth Street, Hollister, CA)",
  "Cenic-Columbine Elem. (2240 Road 160, Delano)",
  "Cenic-Cuyama Elem (2300 Highway 166, New Cuyama)",
  "Cenic-Hopeton School (2241 West Turlock Rd. Snelling)",
  "Cenic-Jefferson Elem. (221 Old Hernandez Rd, Paicines)",
  "Cenic-Mountain High Sch. (2 Pinecrest school Rd, Pinecrest)",
  "Cenic-Pine Grove Elem. (217 Rex Ave, Jackson, CA)",
  "Cenic-Pioneer Elem. (217 Rex Ave, Jackson)",
  "Cenic-Pleasant View Elem. (14004 Road 184, Porterville)",
  "Cenic-Plum Valley Elem.- (22630 Antelope Blvd, Red Bluff)",
  "Cenic-R.O.P- Sierra Ridge Acd. (10400 Fricot City Rd, San Andreas)",
  "Cenic-Robbins Elem (17451 Pepper Street, Robbins)",
  "Cenic-Semitropic Elm (25300 Highway 46, Wasco, CA)",
  "Chalan CA Solar Storage",
  "City of Fresno",
  "City of Fresno - 1077 Van Ness Ave",
  "City of Fresno - 801 Van Ness Ave",
  "City of Fresno - O St",
  "City of Visalia Convention Center",
  "Coalinga-Huron Joint Unified Sch Dist.",
  "Coalinga-Huron Joint Unified Sch Dist. (16875 4th Huron)",
  "Coalinga-Huron Joint Unified Sch Dist. (300 E. Cherry Lane, Coalinga)",
  "Coalinga-Huron Joint Unified Sch Dist. (36131 N Street Huron, CA)",
  "Coalinga-Huron Joint Unified School District",
  "COMCAST",
  "Community Health Centers Of America- (1300 N Fresno St. Fresno)",
  "Community Holdings Management",
  "Community Holdings Management-NorthStar Handford",
  "Conduit Relocation - Caltrans Proposed Project 03-0N780",
  "Conduit Relocation - SR99, Nevada City",
  "Corcom Communication",
  "Corcom Communications Inc",
  "County of Fresno- Palm St",
  "County of Fresno-(2171 N. Fine Ave, Fresno)",
  "Crop Management Co (Strathmore)",
  "Dakota Fresno LLP",
  "De Groot Dairies",
  "Delhi Unified Sch Dist. (101115 Fifth St, Delhi)",
  "Delhi Unified Sch Dist. (16304 Dehli Ave Dehli)",
  "Delhi Unified Sch Dist. (16464 August Ave, Delhi)",
  "Delhi Unified Sch Dist. (16881 Schendel Ave Delhi)",
  "Delhi Unified Sch Dist. (16881 Schendel Ave, Delhi)",
  "Dinuba Hardware Upgrade",
  "Dish Networks",
  "EcoWater of Central California (287 W Fallbrook Ave Ste 101 Fresno)",
  "EECU",
  "Exeter Hardware Upgrade",
  "FHA Modoc Project",
  "Fiber Cutover - Hillman St",
  "Foundation for Medical Care",
  "Fresno County Superintendent of Schools (1111 Van Ness Ave, Fresno)",
  "Fresno Fiber Expansion",
  "GOLDEN CHARTER ACADEMY (452 N Pacific Ave. Fresno)",
  "Golden Plains Unified S.D. (13883 S Lassen Ave)",
  "Granite Telecommunications - Walmart (Cesar Chavez Blvd)",
  "Granite Telecommunications - Walmart (Herndon Ave)",
  "Granite Telecommunications - Walmart (Shaw Ave)",
  "Granite Telecommunications - Walmart (Twin Cities Rd)",
  "Granite Telecommunications-Walmart (Missouri Flat Rd)",
  "Granville Homes (1170 W Shaw Ave Suite 100)",
  "GTT 3033 Stallion Way",
  "GTT Angles Camp",
  "H&R Block-DIA (943 G St., Reedley)",
  "H&R Block-VoIP (943 G St., Reedley)",
  "Handhole Relocation - Reedley",
  "Hard Rock – Tejon (1777 Garone Farm Rd, Mettler CA)",
  "Harris Woolf California Almonds",
  "Harvest Wealth Group (160 S. E ST Exeter)",
  "Indatel - Health Human Services",
  "Indatel Services",
  "Indatel Services (151 Vultee Ave, Shafter)",
  "Indatel Services (5435 Price, Mcclellan)",
  "Indatel Services (624 S Grand Ave, Los Angeles CA)",
  "Integrity Networks  Kings Canyon",
  "Intervalley Insurance Services (4221 N Fresno St Fresno)",
  "Intrade Industries",
  "Jeffrey Scott Agency",
  "Juniper Springs Healthcare, Inc.",
  "Kern County  - Mt Vernon and Center St - Damaged Storm Drain Repair",
  "Kings Canyon Unified SIP",
  "Lithia Motors",
  "Maxco Packaging",
  "Maxco Packaging- Olsen St (Reedley)",
  "Merced County Association of Government",
  "Merced County Office of Education",
  "Merced Union High School (168 Business Park Way, 95301)",
  "Merced Union High School-(3500 G st, 95340)",
  "Metro Hospitality Group, Inc",
  "Nitel USA - Friant Rd",
  "O'Neill Vintners- (8419 S Lac Jac Ave, Parlier)",
  "OACYS Technology (757 N Porter Rd. Porterville)",
  "PGE",
  "PGE - Angles Camp",
  "PGE - Bell Sub",
  "PGE - Fourth Ave",
  "PGE - Jackson SC",
  "PGE - Marty Ave Substation",
  "PGE - Shaw Ave",
  "PGE Stockton to Jackson Dark Fiber Route Splicing",
  "PGE Table Mountain",
  "PGE Table Mountain (Contractor)",
  "Prime Comms Retail (3640 W Shaw Ave, Suite 104, Clovis)",
  "Race Communications",
  "RD Offutt Company (5700 S Mandarin Ave)",
  "Restoration",
  "Restoration - Amador County",
  "Restoration - Butte County",
  "Restoration - Calaveras County",
  "Restoration - Colusa County",
  "Restoration - El Dorado County",
  "Restoration - Fresno County",
  "Restoration - Glenn County",
  "Restoration - Kern County",
  "Restoration - Kings County",
  "Restoration - Lassen County",
  "Restoration - Mariposa County",
  "Restoration - Merced County",
  "Restoration - Modoc County",
  "Restoration - Monterey County",
  "Restoration - Nevada County",
  "Restoration - Placer County",
  "Restoration - Sacramento County",
  "Restoration - San Benito County",
  "Restoration - San Francisco County",
  "Restoration - San Joaquin County",
  "Restoration - San Mateo County",
  "Restoration - Santa Clara County",
  "Restoration - Santa Cruz County",
  "Restoration - Shasta County",
  "Restoration - Siskiyou County",
  "Restoration - Solano County",
  "Restoration - Stanislaus County",
  "Restoration - Sutter County",
  "Restoration - Tehama County",
  "Restoration - Tulare County",
  "Restoration - Tuolumne County",
  "Restoration - Yolo County",
  "Restoration - Yuba County",
  "Roth Enterprises",
  "Selma Unified School District-Abraham Lincoln Middle School",
  "Selma Unified School District-Eric White Elm Sch",
  "Selma Unified School District-Garfield Elem Sch",
  "Selma Unified School District-Heartland Alternative Center",
  "Selma Unified School District-Indianola Elm Sch",
  "Selma Unified School District-Jackson Elem Sch",
  "Selma Unified School District-Roosevelt Elem Sch",
  "Selma Unified School District-Selma Adult Sch",
  "Selma Unified School District-Selma High Sch",
  "Selma Unified School District-Terry Elem. Sch",
  "Selma Unified School District-Warehouse/Transportation",
  "Selma Unified School District-Wilson Elem. Sch",
  "Spectrotel",
  "St. Helen Elem. Sch - 4888 E Belmont Ave, Fresno",
  "Stanford Geophysics",
  "Stanford Geophysics (Kansas Ave and 18th, Lemoore)",
  "Stanford Geophysics (W Hillsdale Ave & N Akers St, Visalia)",
  "Tejon Gaming Authority - Water Treatment Plant",
  "Tejon Gaming Authority-Sheriff",
  "Thandi Enterprises (Jensen Hotel)",
  "Topanga Hanford MDU",
  "True Hotels Inc",
  "Tulare Joint Union High S.D. (426 N Blackstone, Fresno)",
  "Tulare Joint Union High School District",
  "Turning Point Mineral King",
  "Universal Network Services",
  "Universal Network Services (6610 W RIGGIN, VISALIA)",
  "Universal Network Services (Riggin Visalia)",
  "UNIVERSAL NETWORKS-BIG CREEK, CA",
  "Universal Networks-Regal Enterta",
  "Unwired Renewal Multiple Sites",
  "UnWired-Lost Hills",
  "Utility Relocation",
  "Vault Adjustment - Brisbane",
  "Verizon - CANO Paramount",
  "Verizon Downtown Oakhurst",
  "Verizon Wireless",
  "Verizon Wireless - (Walnut Creek)",
  "Verizon Wireless - Dustin Acres",
  "Verizon Wireless (23320 Red Corral Road)",
  "Verizon Wireless (Bakersfield)",
  "Verizon Wireless (Delano)",
  "Verizon Wireless (Eugene)",
  "Verizon Wireless (Hanford)",
  "Verizon Wireless (Hughson)",
  "Verizon Wireless (Kettleman)",
  "Verizon Wireless (Newman)",
  "Verizon Wireless (Oakdale)",
  "Verizon Wireless (Porterville)",
  "Verizon Wireless Dinuba",
  "Verizon Wireless Pixley",
  "Verizon Wireless- Robin Ave (Livingston )",
  "Verizon Wireless-HWY 41 & Nevada",
  "Verizon Wireless-Oakdale",
  "Verizon- Valley Home",
  "Verizon-Bootjack",
  "Volcano Vision",
  "Washington Unified School Dist. (1111 Van Ness Ave. Fresno)",
  "Washington Unified School Dist. (2801 W. Adams Ave. Fresno)",
  "Washington Unified School Dist. (2888 S. Ivy Ave Fresno)",
  "Washington Unified School Dist. (7950 S Elm ave Fresno,)",
  "Washington Unified School Dist.(6401 Elm, Fresno)",
  "Waukena Joint Union Elem. Sch Dist (6200 S Mooney Blvd, Visalia)",
  "Weaver Union School Dist (3076 E. Childs Ave, Merced)",
];

export default CUSTOMERS;
